import document from './document';

export default {
    document,
};
